import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import { getLockDuration } from 'helpers/otpErrors';
import Alert from 'components/Alert';
import App from 'modules/App';
const OtpLockInfo = ({ lockoutDuration, hasErrors })=>{
    const intl = useIntl();
    if (!lockoutDuration || hasErrors) {
        return null;
    }
    const { duration: lockDuration, unit } = getLockDuration(lockoutDuration);
    const lockUnit = intl.formatMessage(App.messages.timeUnits[unit]);
    return /*#__PURE__*/ _jsx("div", {
        className: "mb-3",
        children: /*#__PURE__*/ _jsx(Alert, {
            type: "error",
            message: App.messages.errors.businessErrors.InvalidOTPEntryLock,
            messageValues: {
                lockDuration,
                lockUnit
            }
        })
    });
};
export default OtpLockInfo;
